import LocaleModel from 'src/model/modules/locale.model';

const moduleSel = (store: any): LocaleModel => store.locale;

export const regionSel = (store: any) => moduleSel(store).region;
export const languageSel = (store: any) => moduleSel(store).language;
export const noCountryLanguageSel = (store: any) => {
  const language = moduleSel(store).language.split('-');
  return language[0];
};
export const currencySel = (store: any) => moduleSel(store).currency;
